import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SashOffer from "@/pages/SashOffer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/sashbagoffer" element={<SashOffer />} />
          <Route path="/" element={<Navigate to="/sashbagoffer" replace />} />
          <Route path="*" element={<Navigate to="/sashbagoffer" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
